module.exports = __webpack_public_path__ + "img/biopharma-logo.7d4ddf78.jpg";